import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import RequestsPage from '../../../pages/travel-expense/detail/admin';
import ManagerReportsPage from '../../../pages/travel-expense/reports/manager/index';
import AccountingRequestsPage from '../../../pages/travel-expense/detail/accounting';
import HrRequestsPage from '../../../pages/travel-expense/detail/hr';
import SideBar from '../sidebar';
import Header from '../../header';
import Footer from '../../footer';
import NotFound from '../../../pages/not-found';
import HelpPage from '../../../pages/help';
import ErrorPage from '../../../pages/error';
import * as authActions from '../../../redux/modules/auth';
import cookieAndLocalStorage from '../../../helpers/cookieAndLocalStorage';
import { startTokenChecker, stopTokenChecker } from '../../../helpers/TokenChecker';

class App extends Component {
  async componentDidMount() {
    const { isCheckToken, isActive } = this.props;
    if (isActive === false) {
      cookieAndLocalStorage();
      return;
    }
    // İlk anda hemen token kontrolü yap
    await isCheckToken();
    // Sonra periyodik kontrolü başlat
    startTokenChecker(isCheckToken);
  }

  componentWillUnmount() {
    stopTokenChecker();
  }

  componentDidUpdate() {
    if (this.props.isActive === false) {
      cookieAndLocalStorage();
    }
  }

  render() {
    return (
      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Header />

          <div className="content">
            <div className="container-fluid">
              <Switch>
                <Redirect exact from="/" to="/requests" />
                <Route path="/requests/:page?" component={RequestsPage} />
                <Route
                  path="/accounting/requests/:page?"
                  component={AccountingRequestsPage}
                />
                <Route path="/hr/requests/:page?" component={HrRequestsPage} />
                <Route path="/reports" component={ManagerReportsPage} />
                <Route path="/help" component={HelpPage} />
                <Route path="/error" component={ErrorPage} />

                <Route component={NotFound} />
              </Switch>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  isActive: state.auth.isActive,
});

export default connect(mapStateToProps, authActions)(App);



// WEBPACK FOOTER //
// ./src/components/admin/containers/App.js